<template>
  <div id="visitObject">
    <!-- <el-dialog
      :visible.sync="showDialogVisible"
      :close-on-click-modal="false"
      width="240px"
      height="300px"
    >
      <el-form inline size="small">
        <template>
          <div id="qrcodes">
            <vue-qr
              ref="QRCode"
              class="qrcode"
              :text="text"
              :size="200"
            />
          </div>
        </template>
      </el-form>
      <div slot="footer">
        <el-button @click="showDialogVisible = false">
          取 消
        </el-button>
        <el-button type="success" @click="downloadQRCode()">
          下载二维码
        </el-button>
      </div>
    </el-dialog> -->
    <el-form inline size="small">
      <el-form-item label="姓名">
        <el-input v-model="searchForm.name" placeholder="请输入姓名" clearable />
      </el-form-item>
      <el-form-item label="单位名称">
        <el-input v-model="searchForm.companyName" placeholder="请输入单位名称" clearable />
      </el-form-item>
      <el-form-item label="身份证号码">
        <el-input v-model="searchForm.idNumber" placeholder="请输入身份证号码" clearable />
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="searchForm.phoneNumber" placeholder="请输入手机号" clearable />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">
          查 询
        </el-button>
        <el-button type="primary" icon="el-icon-download" @click="handleExport">
          导出
        </el-button>
      </el-form-item>
    </el-form>

    <el-table
      id="xls-table"
      ref="mainTableRef"
      :data="mainTable.list"
      row-key="bid"
      default-expand-all
      height="75vh"
      :cell-style="{padding: '6px'}"
      :header-cell-style="{background: '#f8f8f9'}"
      @row-click="handleRowClick"
    >
      <el-table-column prop="name" label="序号" width="50">
        <template slot-scope="scope">
          {{ (searchForm.pageNum-1)*searchForm.pageSize + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="name" label="姓名" width="80" align="center" />
      <el-table-column prop="companyName" label="单位名称" width="150px" align="center" />
      <el-table-column prop="idNumber" label="身份证号码" width="175" align="center" />
      <el-table-column prop="phoneNumber" label="手机号" width="120" align="center" />
      <el-table-column prop="businessDept" label="业务科室" width="120" align="center" />
      <el-table-column prop="businessPlace" label="业务场所" width="80" align="center" />
      <el-table-column prop="businessContent" label="业务内容" align="center" />
      <el-table-column prop="remark" label="涉及产品" width="80" align="center" />
      <el-table-column prop="type" label="备案访问类型" width="110" align="center">
        <template slot-scope="scope">
          {{ getType(scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="备案日期" width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.createTime ? scope.row.createTime.split(' ')[0] : '' }}
        </template>
      </el-table-column>
      <el-table-column prop="product" label="备注" width="150" align="center" />
      <el-table-column prop="commitmentPic" label="廉洁承诺书" width="130" align="center">
        <template slot-scope="scope">
          <el-image
            :src="`${BASEURL}/files/${scope.row.commitmentPic}`"
            :preview-src-list="[`${BASEURL}/files/${scope.row.commitmentPic}`]"
          ></el-image>
          <el-button type="text" size="mini" @click="handleDownload(scope.row.commitmentPic)">下载图片</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="companyCertificatePic" label="工作单位证明" width="130" align="center">
        <template slot-scope="scope">
          <el-image
            :src="`${BASEURL}/files/${scope.row.companyCertificatePic}`"
            :preview-src-list="[`${BASEURL}/files/${scope.row.companyCertificatePic}`]"
          ></el-image>
          <el-button type="text" size="mini" @click="handleDownload(scope.row.companyCertificatePic)">下载图片</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="idNumberPic" label="身份证复印件" width="130" align="center">
        <template slot-scope="scope">
          <el-image
            :src="`${BASEURL}/files/${scope.row.idNumberPic}`"
            :preview-src-list="[`${BASEURL}/files/${scope.row.idNumberPic}`]"
          ></el-image>
          <el-button type="text" size="mini" @click="handleDownload(scope.row.idNumberPic)">下载图片</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :total="mainTable.total"
      :current-page="searchForm.pageNum"
      :page-size="searchForm.pageSize"
      :page-sizes="[10, 15, 20]"
      layout="total, sizes, prev, pager, next, jumper"
      background
      @current-change="pageNumChange"
      @size-change="pageSizeChange"
    />
  </div>
</template>

<script>
import { getFilingList, filingOutput} from '@/api/medicine/filing.js'
export default {
  name: 'filingRecord',
  data () {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        type: 3,
      },
      mainTable: {
        total: 0,
        list: []
      },
      BASEURL: window.g.BASE_URL,
    }
  },
  mounted() {
    this.getMainList()
  },
  methods: {
    handleDownload(name) {
      const url = `/api/files/${name}`;  // 使用代理路径
  
      fetch(url)
        .then(response => {
          if (!response.ok) throw new Error('下载失败');
          return response.blob();
        })
        .then(blob => {
          const link = document.createElement('a');
          const blobUrl = URL.createObjectURL(blob);
          link.href = blobUrl;
          link.download = name;
          link.click();
          URL.revokeObjectURL(blobUrl);
        })
        .catch(error => {
          console.error('下载失败:', error);
          this.$message?.error('下载失败');
        });
    },
    getType(type) {
      // 1，药品；2，医用耗材； 3.设备
      let str = ''
      switch (type) {
        case 1:
          str = '药品'
          break
        case 2:
          str = '医用耗材'
          break
        default:
          str = '设备'
          break;
      }
      return str
    },
    getMainList() {
      const loadingInstance = this.$loading({
        fullscreen: true,  // 是否全屏
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      getFilingList(this.searchForm)
        .then((res) =>{
          this.mainTable = res
        }).finally(() => {
          loadingInstance.close()
        })
    },
    handleRowClick (row, col, event) {
      this.$refs.mainTableRef.toggleRowExpansion(row)
    },
    pageNumChange (pageNum) {
      this.searchForm.pageNum = pageNum
      this.getMainList()
    },
    pageSizeChange (pageSize) {
      this.searchForm.pageSize = pageSize
      this.pageNumChange(1)
    },
    handleSearch () {
      this.pageNumChange(1)
    },
    async handleExport() {
      const res = await filingOutput(this.searchForm);
      const url = URL.createObjectURL(res);
      const link = document.createElement("a");
      link.href = url;
      link.download = `备案记录.xlsx`;
      link.click();
      URL.revokeObjectURL(res);
    },
  }
}
</script>

<style scoped>

</style>
